import { TableCell, TableRow } from "../../../design/table";
import { Question } from "../../../models/Question";
import { Checkbox } from "../../../design/checkbox";
import { useState } from "react";
import { useQuestion } from "../../../contexts/QuestionContext";

interface QuestionListItemProps {
  question: Question;
}

const QuestionListItem: React.FC<QuestionListItemProps> = ({ question }) => {
  const { updateQuestion } = useQuestion();
  return (
    <TableRow>
      <TableCell style={{ whiteSpace: "pre-line" }}>
        <div className="flex flex-col">
          <span>{question.question}</span>
        </div>
      </TableCell>
    </TableRow>
  );
};
export default QuestionListItem;
